/*  export default {
    apiKey: "AIzaSyAaODb7bCoZPvV4gdVyG_sV_Lc1_GuVdwg",
    authDomain: "react-intro-37cd1.firebaseapp.com",
    databaseURL: "https://react-intro-37cd1.firebaseio.com",
    projectId: "react-intro-37cd1",
    storageBucket: "react-intro-37cd1.appspot.com",
    messagingSenderId: "181293593583"
  };  */

  /*export default {
  apiKey: "AIzaSyC7_3ewOvmqD1b4IME3XTQ4tSxMiwKwTdY",
  authDomain: "baal-dahab.firebaseapp.com",
  databaseURL: "https://baal-dahab.firebaseio.com",
  projectId: "baal-dahab",
  storageBucket: "baal-dahab.appspot.com",
  messagingSenderId: "136131151926",
  appId: "1:136131151926:web:57e8cc93c4fd5eaf38f097"
  }*/

  //import firebase from 'firebase/app';
 

  /*const firebaseConfig = {
    apiKey: "AIzaSyC7_3ewOvmqD1b4IME3XTQ4tSxMiwKwTdY",
    authDomain: "baal-dahab.firebaseapp.com",
    databaseURL: "https://baal-dahab.firebaseio.com",
    projectId: "baal-dahab",
    storageBucket: "baal-dahab.appspot.com",
    messagingSenderId: "136131151926",
    appId: "1:136131151926:web:57e8cc93c4fd5eaf38f097"
  };*/
 
 import firebase from 'firebase';
  var firebaseConfig = {
    apiKey: "AIzaSyAQ6V6X8FLFkA9Wxas3Xpw2vnpfqwPixvE",
    authDomain: "baal-dahab.firebaseapp.com",
    databaseURL: "https://baal-dahab.firebaseio.com",
    projectId: "baal-dahab",
    storageBucket: "baal-dahab.appspot.com",
    messagingSenderId: "136131151926",
    appId: "1:136131151926:web:512b44eb8cf36fe038f097"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  export default firebase 